import React, { FC } from 'react';

import { AccessGrant } from '@ariksa/inventory-core';

import { StackedCell } from 'components/DataDisplay';

import { RoleGrantLink } from './RoleGrantLink';
import { getGrantType, isRoleGrant } from './utils';

export interface GrantNameCellProps {
  grant?: AccessGrant;

  onClickRole(grant: AccessGrant): void;

  isRoleLoading(grant: AccessGrant): boolean;
}

/** One grant: the policy's name or "via <role>", and what kind it is. */
export const GrantNameCell: FC<GrantNameCellProps> = props => {
  const { grant, onClickRole, isRoleLoading } = props;
  if (!grant) return <>-</>;

  if (isRoleGrant(grant)) {
    return (
      <StackedCell
        upper={
          <RoleGrantLink
            grant={grant}
            onClick={onClickRole}
            isLoading={isRoleLoading(grant)}
          />
        }
        // The link has its own tooltip.
        showUpperTooltip={false}
        lower={getGrantType(grant)}
      />
    );
  }
  return <StackedCell upper={grant.name ?? '-'} lower={getGrantType(grant)} />;
};
